import React from 'react';
import { Controller } from 'react-hook-form';

import {
    FormControl,
    //   OutlinedInput,
    InputAdornment,
    FormLabel,
    FormHelperText,
    Select,
    MenuItem
} from '@mui/material';

import { styled } from '@mui/material/styles';
import { ISelectOption, ISelectProps } from '../interfaces';

const OutlinedSelectWrapper = styled(Select)(
    ({ theme }) => ({
        backgroundColor: theme.colors.alpha.white[100],
        border: 0,
        borderRadius: 0,
        menuItemRoot: {
            background: 'red'  
        },
        menuItem: {
            background: 'blue'
        },
        '& fieldset': {
            border: '1px solid  #AEACAC !important',
            borderRadius: 4,
        },
        '&.MuiPaper-root': {
            border: '1px solid #AEACAC',
            borderRadius: 8,
            marginTop: 4
        },

    })
);

const SelectCtrl = ({
    control,
    showError,
    //   className,
    placeholder,
    name,
    required,
    //   componentName,
    disabled,
    id,
    //   defaultValue,
    //   hint,
    //   type,
    startAdornment,
    endAdornment,
    startAdornmentIcon,
    endAdornmentIcon,
    label,
    options
}: ISelectProps) => {
    const rules: any = {
        required: required,
        pattern: {
            value: /[A-Za-z0-9]{1,20}/,
            message: 'Field is invalid'
        }
    };
    return (
        <Controller
            rules={rules}
            name={name}
            control={control}
            render={({ field, fieldState }) => (
                <>
                    <FormControl
                        variant="outlined"
                        fullWidth
                        sx={{
                            margin: '0 0 16px'
                        }}
                        size="small"
                    >
                        <FormLabel component="legend">{label}</FormLabel>
                        <OutlinedSelectWrapper
                            {...field}
                            id={id}
                            disabled={disabled}
                            // native={false}
                            //   children={() => <MenuItem disabled value="">skdjabsdkj</MenuItem>}
                            //   children={{options.map((option: ISelectOption, idx: number) => (
                            //     <MenuItem key={idx} value={option.value}>
                            //       {option.label}
                            //     </MenuItem>
                            //   ))}}
                            // placeholder={"test"}
                            value={field.value ? field.value : ''}
                            endAdornment={
                                endAdornmentIcon ? (
                                    <InputAdornment position="end">
                                        {endAdornmentIcon}
                                    </InputAdornment>
                                ) : (
                                    endAdornment
                                )
                            }
                            startAdornment={
                                startAdornmentIcon ? (
                                    <InputAdornment position="start">
                                        {startAdornmentIcon}
                                    </InputAdornment>
                                ) : (
                                    startAdornment
                                )
                            }
                            displayEmpty={true}
                            className="hideBackdrop"
                            MenuProps={{
                                sx: {
                                    '&& .MuiPaper-root': {
                                        boxShadow: 'none',
                                        border: '1px solid #AEACAC',
                                        marginTop: '3px'
                                    },
                                    '&& .hide': {
                                        // visibility: 'hidden',
                                        display: 'none'
                                    }
                                }
                            }}

                        >
                            <MenuItem className="hide" disabled value="" hidden>
                                {placeholder}
                            </MenuItem>
                            {options.map((option: ISelectOption, idx: number) => (
                                <MenuItem key={idx} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </OutlinedSelectWrapper>
                        <FormHelperText
                            error
                            variant="outlined"
                            sx={{
                                fontWeight: 'normal'
                            }}
                        >
                            {showError(name)}
                        </FormHelperText>
                    </FormControl>
                </>
            )}
        ></Controller>
    );
};

export default SelectCtrl;
